import EmployeesTable from './GroupTable';

export type { EmployeesTableProps } from './GroupTable';

export default EmployeesTable;
